import { HttpClient } from '@angular/common/http';
import { ApplicationConfig, importProvidersFrom, LOCALE_ID } from '@angular/core';

import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';

import { environment } from '../environments/environment';

export function createTranslateLoader(http: HttpClient) {
  let path = './assets/i18n/';
  if (environment.translationsSource === 'server') {
    path = environment.api.host + '/lokalise/';
  }
  return new TranslateHttpLoader(http, path, '.json');
}

// INFO MPS : This file allows you to add providers specific to your application
// without modifying the bootstrap configuration in 'mps.config.ts'.
export const applicationConfig: ApplicationConfig = {
  providers: [
    { provide: LOCALE_ID, useValue: 'fr' },
    importProvidersFrom(
      TranslateModule.forRoot({
        defaultLanguage: environment.defaultLocale,
        loader: {
          provide: TranslateLoader,
          useFactory: createTranslateLoader,
          deps: [HttpClient],
        },
      })
    ),
  ],
};
